import Schema from './Schema'
import FieldInput from'../fields/FieldInput'
export default class SchemaInput extends Schema {
  constructor(label, key, rules, options, on) {
    super(options)
    FieldInput.call(this, label, key, rules, options, on)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaInput.js